/**
 * CTAButton.jsx
 * Reusable Call-To-Action button component for QuitPact.
 *
 * AC 1.1.2 – AC tasks covered:
 *   - Labelled "Check My Relapse Risk" by default (overridable via `label` prop)
 *   - Distinct primary/high-contrast colour via CSS class
 *   - Larger than normal buttons (size enforced in CTAButton.css)
 *   - Hover / active / focus states defined in stylesheet
 *   - Keyboard accessible: responds to Tab + Enter natively as a <button>
 *   - Accessible label via aria-label (falls back to visible text)
 *
 * Props:
 *   label       {string}   Button text — defaults to "Check My Relapse Risk"
 *   onClick     {func}     Click handler (optional; use with non-link usage)
 *   to          {string}   React Router path to navigate to (optional)
 *   ariaLabel   {string}   Override accessible label (optional)
 *   disabled    {bool}     Disables interaction (optional)
 *   className   {string}   Extra CSS classes (optional)
 *
 * Team: TA37 - The Coders' Assembly
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CTAButton.css';

const CTAButton = ({
  label = 'Check My Relapse Risk',
  onClick,
  to,
  ariaLabel,
  disabled = false,
  className = '',
  type = 'button',          // NEW: allow overriding button type
}) => {
  const navigate = useNavigate();

  const handleClick = (event) => {
    if (disabled) return;

    if (to) {
      event.preventDefault();  // prevent form submit on navigation buttons
      navigate(to);
    } else if (onClick) {
      onClick(event);          // pass event through
    }
  };

  return (
    <button
      className={`cta-button ${className}`}
      onClick={handleClick}
      aria-label={ariaLabel || label}
      disabled={disabled}
      type={type}
    >
      {label}
    </button>
  );
};

export default CTAButton;